exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.no-bg[data-v-787c2acd] {\n  -webkit-box-shadow: none !important;\n}\n", ""]);

// exports
